import React, { FC, memo } from 'react'
import { ISchoolInfoProps, TObjectWithName } from '../types'
import { Item } from '../components/Item'

const joinByName = (arr: TObjectWithName[]): string =>
  arr?.map(({ name }) => name).join(', ')

const SchoolInfo: FC<ISchoolInfoProps> = ({ data }) => {
  if (!data) return null

  const {
    additionalInformation,
    admissionConditions,
    classesFrom,
    classesTo,
    egeMore160,
    egeMore220,
    egeResultsDescription,
    electives,
    foreignLanguages,
    isFree,
    musicalInstruments,
    openingTimeFrom,
    openingTimeTo,
    otherSection,
    otherSubject,
    price,
    profileElementary,
    schoolAdditionalFeatures,
    schoolExamResult,
    schoolMiddleProfiles,
    schoolProfiles,
    schoolType: { name: schoolTypeName },
    sports,
    universities,
    universityProfileClasses,
  } = data

  let egeResult
  if (egeResultsDescription) {
    egeResult = egeResultsDescription
  } else if (egeMore160 && egeMore220) {
    egeResult = `Более 160 баллов за 3 предмета - ${egeMore160}%; Более 220 баллов за 3 предмета - ${egeMore220}%`
  }

  const profiles = joinByName(schoolProfiles)
  const middleProfiles = joinByName(schoolMiddleProfiles)
  const languages = foreignLanguages?.join(', ')
  const instruments = joinByName(musicalInstruments)
  const sport = joinByName(sports)
  const additionalFeatures = joinByName(schoolAdditionalFeatures)
  const universitiesLinks = joinByName(universities)

  let time = ''
  if (openingTimeFrom) {
    time += `С ${openingTimeFrom}`
  }
  if (openingTimeTo) {
    time += ` По ${openingTimeTo}`
  }

  return (
    <>
      <Item title='Тип' description={schoolTypeName} />
      <Item title='Классы' description={`С ${classesFrom} по ${classesTo}`} />
      {egeResult && <Item title='Общий результат ЕГЭ' description={egeResult} />}
      {schoolExamResult?.length > 0 && (
        <Item title='Средний результат ЕГЭ' description={schoolExamResult} />
      )}
      {profileElementary && (
        <Item
          title='Программа обучения в начальной школе'
          description={profileElementary}
        />
      )}
      {profiles && (
        <Item title='Профиль обучения в средней школе' description={profiles} />
      )}
      {middleProfiles && (
        <Item title='Профиль обучения в старшей школе' description={middleProfiles} />
      )}
      {universityProfileClasses && (
        <Item
          title='Профильные классы при вузах'
          description={universityProfileClasses}
        />
      )}
      {admissionConditions && (
        <Item title='Условия поступления' description={admissionConditions} />
      )}
      {languages && <Item title='Иностранные языки' description={languages} />}
      {instruments && <Item title='Музыкальные инструменты' description={instruments} />}
      {otherSubject && <Item title='Нестандартные предметы' description={otherSubject} />}
      {electives && <Item title='Факультативы' description={electives} />}
      {otherSection && <Item title='Кружки и секции' description={otherSection} />}
      {sport && <Item title='Виды спорта' description={sport} />}
      {additionalFeatures && (
        <Item title='Дополнительно' description={additionalFeatures} />
      )}
      {universitiesLinks && (
        <Item title='Сотрудничество с вузами' description={universitiesLinks} />
      )}
      {(isFree || (!isFree && price)) && (
        <Item
          title='Стоимость обучения'
          description={isFree ? 'Бесплатно' : `${price} рублей в год`}
        />
      )}
      {time && <Item title='Режим работы' description={time} />}
      {additionalInformation && (
        <Item title='Факты о школе' description={additionalInformation} />
      )}
    </>
  )
}

export default memo(SchoolInfo)
